<div class="container">

    <app-header-dialog [iconName]="'live_tv'">
     Webinars
  </app-header-dialog>

    <div class='tab-content'>

        <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
                autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                O nome é obrigatório
            </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name_en"
                autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name_en.hasError('required')">
                O nome EN é obrigatório
            </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="outline">
            <mat-label>URL Youtube</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.url"
                autocomplete="off">
            <mat-error *ngIf="entityForm.controls.url.hasError('required')">
                A Url é obrigatória.
            </mat-error>
        </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <div [ngClass]="{hidden: !spinner}">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
        <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
    </div>

</div>